import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';

export const FoodAllowanceSettings = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <Card className="border-0 shadow-md" data-testid="food-allowance-settings"><CardContent className="p-5 space-y-3">
      <div>
        <h3 className="font-semibold">Night food allowance</h3>
        <p className="text-sm text-gray-500">Regular staff and drivers whose approved check-out is after this time (after midnight) get food + tea. Printed from <b>Daily → Food Allowance</b>.</p>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-1 text-sm">Food ₹<Input type="number" min={0} value={value.food} onChange={set('food')} className="w-[90px] bg-white" data-testid="settings-food-amount" /></label>
        <label className="flex items-center gap-1 text-sm">Tea ₹<Input type="number" min={0} value={value.tea} onChange={set('tea')} className="w-[90px] bg-white" data-testid="settings-tea-amount" /></label>
        <label className="flex items-center gap-1 text-sm">Check-out after<Input type="time" value={value.after} onChange={set('after')} className="w-[120px] bg-white" data-testid="settings-food-after" /></label>
      </div>
    </CardContent></Card>
  );
};
